import { Divider } from "antd";
import HeaderCarousel from "./HeaderCarousel";
import Explore from "./Explore";
import Featured from "./Featured";
import ResaturantDeliverings from "./ResaturantDeliverings";

const Home=()=>{

    return(
        <div style={{ padding: '0 48px' }}>
<HeaderCarousel/>
<Divider/>
<Explore/>

<Divider/>
<Featured title={"Featured Restaurants"}/>
<Divider/>

<Featured title={"Order Again"}/>
<Divider/>
<ResaturantDeliverings/>
        </div>
    )
}
export default Home;